// capacitorInit.js
// ---------------------------------------------------------------------------
// When the app runs inside the native Android (Capacitor) shell, the web bundle
// is served from a local origin (e.g. https://localhost or capacitor://).
// Relative calls like fetch('/api/...') would therefore resolve against that
// local origin instead of the real backend. This shim rewrites those calls to
// the production backend so the bundled app behaves exactly like the website.
//
// On the plain website (car-track.app) this code is a no-op: it only activates
// when Capacitor reports a native platform.
// ---------------------------------------------------------------------------

// Production backend origin. Override at build time with VITE_API_ORIGIN.
export const API_ORIGIN =
  import.meta.env.VITE_API_ORIGIN || 'https://car-track.app';

function isNative() {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
}

export function initApiOrigin() {
  if (!isNative()) return; // website: leave fetch untouched

  const nativeFetch = window.fetch.bind(window);

  // Rewrite root-relative API/proxy paths to the absolute backend origin.
  const rewrite = (url) => {
    if (typeof url === 'string' && (url.startsWith('/api') || url.startsWith('/proxy'))) {
      return API_ORIGIN + url;
    }
    return url;
  };

  window.fetch = (input, init) => {
    if (typeof input === 'string') {
      return nativeFetch(rewrite(input), init);
    }
    // Request object
    if (input && typeof input.url === 'string' && (input.url.startsWith('/api') || input.url.startsWith('/proxy'))) {
      return nativeFetch(new Request(API_ORIGIN + input.url, input), init);
    }
    return nativeFetch(input, init);
  };
}
